module.exports = __webpack_public_path__ + "static/media/clear_circle.1287c7cd.svg";